export const budgetLandscapeLegacyStrings = [{
  ColumnName_EstimatedSharedBudget: _TL_('Shared budget'),
  ColumnName_SharedBudgetAmount: _TL_('Shared budget'),
  ColumnName_BudgetAmount: _TL_('Budget'),
  ColumnName_EstimatedBudget: _TL_('Budget'),
  ColumnName_EstimatedImpressions: _TL_('Weekly est. impr.'),
  ColumnName_EstimatedClicks: _TL_('Estimated clicks'),
  ColumnName_EstimatedConversions: _TL_('Estimated conversions'),
  ColumnName_EstimatedCost: _TL_('Weekly est. spend'),
  BudgetLandscape_Table_Budget_Tip_Forecasting: _TL_('Your campaign may be limited by budget in the coming weeks if you select an amount less than {0}.'),
  BudgetLandscape_Table_Budget_Tip_Recovery: _TL_('Your campaign may be limited by budget if you select an amount less than {0}.'),
  BudgetLandscape_Table_Budget_Tip: _TL_('Your campaign might still be limited by its budget if you select an amount less than {0}.'),
  ErrorMessage_InputNumericValue: _TL_('Please enter a numeric value, such as 100.'),
  BudgetSuggestionsValidationMsg: _TL_('The budget amount must be between {0} {1} and {2} {3}.'),
  BudgetLandscape_Comment_Recommended: _TL_('(Recommended)'),
  BudgetLandscape_Comment_Current: _TL_('(Current)'),
  BudgetLandscape_Table_CustomInput: _TL_('Other budget'),
  BudgetLandscape_Comment_Suggested: _TL_('(Suggested)'),
  Apply: _TL_('Apply'),
  Cancel: _TL_('Cancel'),
  BudgetLandscape_ConversionStatus_0_linkText: _TL_('UET/Conversion tracking'),
  BudgetLandscape_ConversionStatus_0_line1: _TL_('Budget opportunity support conversion estimation now.'),
  BudgetLandscape_ConversionStatus_0_line2: _TL_('Go to set {0} in order to see conversion information.'),
  BudgetLandscape_ConversionStatus_1: _TL_('Conversion data is not enough.'),
  Validation_Base_Field_Not_Valid: _TL_('Field is not valid'),
  Validation_NotEmpty_Required_Field: _TL_('Required field'),
  Validation_String_Max_Length: _TL_('Field should not exceed {{maxlength}} characters'),
  Validation_String_Min_Length: _TL_('Field should exceed {{minlength}} characters'),
  Validation_String_Invalid_Characters: _TL_('Field contains invalid characters'),
  Validation_Number_Require_Numeric: _TL_('Field requires numeric value'),
  Validation_Number_Max_Length: _TL_('Number should not exceed max length'),
  Validation_Number_Range_Min: _TL_('Number should be larger than {{min}}'),
  Validation_Number_Range_Max: _TL_('Number should be smaller than {{max}}'),
  Validation_Number_Range_Between: _TL_('Number should be between {{min}} and {{max}}'),
  Validation_Array_Size_Max: _TL_('List should have at most {{max}} items'),
  Validation_Array_Size_Between: _TL_('List should have at least {{min}} and at most {{max}} items'),
  Validation_Array_Items_Invalid: _TL_('Some of items in list are invalid'),
  Validation_Array_Items_Duplicate: _TL_('List has duplicate items'),
  Validation_NegativeKeywords_ListName_Required: _TL_('The list name is required.'),
  Validation_NegativeKeywords_Max_Count: _TL_('Maximum of 5,000 negative keywords'),
  Validation_NegativeKeywords_Invalid_Keywords: _TL_('Some of the keyword(s) are invalid: {{invalidKeywords}}'),
  Validation_NegativeKeywords_Required: _TL_('At least 1 negative keyword is required.'),
  'Click to learn more about {{item}}': _TL_('Click to learn more about {{item}}'),
  'Click to scope to campaign {{campaignName}}': _TL_('Click to scope to campaign {{campaignName}}'),
}];
